import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fill'
})
export class FillPipe implements PipeTransform {
    transform(value) {
        return (new Array(value)).fill(1);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fill.pipe.ts